/** Shared read-only contract handle for Phase 2.4-2.7 views on the diamond. Test FRAME only. */
import { ethers } from 'ethers';
import { getReadProvider } from '../utils/contract';
import { CHAIN } from '../config/chain';

export const PHASE2_ABI = [
  'function currentSeason() view returns (uint256 id,uint256 start,uint256 end,uint256 timeLeft,bool rolloverDue)',
  'function seasonFactionStandings(uint256 id) view returns (uint256[8] pts)',
  'function seasonPointsOf(uint256 id,address player) view returns (uint256)',
  'function decayPreview(address player) view returns (uint256 amount,uint8 stage,uint256 lastSeen,uint256 unclaimed)',
  'function factionPools(uint256 roundId) view returns (uint256[9] pools,bool[9] settled)',
  'function factionStreakOf(address player) view returns (uint256 streak,uint256 lastBuyRound)',
  'function previewFactionBonusBps(address player,uint8 faction,uint256 keys) view returns (uint256)',
  'function playerFactionKeys(uint256 roundId,address player) view returns (uint256)',
  'function roundChaosEvents(uint256 roundId) view returns (tuple(bool rolled,uint8 roundEvent,uint8 flashCount,uint8 volcanicCount,uint8 extinctionCount,bool settled,uint32 buys,uint64 nextExtinctionAt,uint256 eventPot))',
  'function extrasConfig() view returns (uint8 mask)',
  'event FlashCrash(uint256 indexed roundId,uint256 until,uint8 count)',
  'event FomoSurge(uint256 indexed roundId,address indexed buyer,uint256 keys,uint256 until)',
  'event ExtinctionEvent(uint256 indexed roundId,address indexed caller,uint256 dropPercent,uint256 newDeadline,uint256 nextAt)',
  'event FactionBonusKeys(uint256 indexed roundId,address indexed player,uint8 indexed faction,uint256 bonusKeys,uint256 bonusBps,uint256 cost)',
  'event RoundEnded(uint256 indexed roundId,address indexed winner,uint256 potSize,uint256 winnerPayout,uint256 dividendsPaid,uint256 rolloverAmount,uint256 communityAmount)',
  'event SeasonFinalized(uint256 indexed season,address first,address second,address third,uint8 winningFaction)',
];

/** Contract faction ids 1-8 (matches LibFaction / FactionBonusPanel). */
export const FACTION_NAMES: Record<number, string> = { 1: 'Raven', 2: 'Ape', 3: 'Moth', 4: 'Viper', 5: 'Rabbit', 6: 'Wolf', 7: 'Fox', 8: 'Owl' };
export const ROUND_EVENT_NAMES: Record<number, string> = { 0: 'none', 1: 'Golden round', 2: 'Lottery round', 3: 'Dividend storm' };

let _c: ethers.Contract | null = null;
export function phase2(): ethers.Contract {
  if (!_c) _c = new ethers.Contract(CHAIN.gameAddress, PHASE2_ABI, getReadProvider());
  return _c;
}

export const fmtFrame = (wei: bigint) => Number(ethers.formatEther(wei)).toLocaleString(undefined, { maximumFractionDigits: 2 });
export const fmtLeft = (s: number) => {
  if (s <= 0) return 'now';
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = Math.floor(s % 60);
  return h > 0 ? `${h}h ${m}m` : m > 0 ? `${m}m ${sec}s` : `${sec}s`;
};
